<template>
  <div class="laid-out-select-input">
    <template v-for="{key, value, caption} in modifyOptions">
      <div :key="key" class="d-flex" :class="{'mb-2': caption}">
        <v-chip
          label
          :outline="!isSelected(key)"
          :dark="isSelected(key)"
          :color="isSelected(key) ? 'primary' : '#616161'"
          @click="onSelect(key)"
          class="py-2"
        >{{ checkExceptionWord(value) }}</v-chip>
        <label v-if="caption" class="fsz-16 mt-1 ml-1">{{transI18n(caption)}}</label> 
      </div>
    </template>
  </div>
</template>

<script>
	export default {
		name: 'LaidOutSelectInput',

		props: {
      options: {
        required: true,
        type: Object
      },

      value: {
        required: false,
        type: [Number, String, Array]
      },
      category: {
        required: false,
        type: String,
        default: ''
      },
      // KAN-53：多選模式（intervention 單選→多選用）。預設 false = 原單選行為，向下相容。
      // 多選時 value 為逗號多值字串（"53,58"）或陣列；點 chip 為 toggle、回傳逗號多值字串。
      // ⚠️ 刻意用新 prop 名 multiSelect，不重用既有的 multiple——後者被 DescriptionRecordsForm /
      // InterventionRecordsForm 對所有 's' 欄位無差別傳 :multiple="true"（元件原本忽略它），
      // 若改成吃 multiple 會讓 morphology / color 等單選欄位一起變多選。故只讓 intervention
      // 明確傳 multiSelect。
      multiSelect: {
        required: false,
        type: Boolean,
        default: false
      },
      transI18n: {
        type: Function,
        default: (key) => key
      }
    },
    data () {
      return {
        prefixObj: {}
      }
    },
    methods: {
      // KAN-53：多選時把 value 正規化為 option key 字串陣列（支援逗號字串 / 陣列 / 空）
      selectedKeys () {
        if (Array.isArray(this.value)) return this.value.map((v) => String(v))
        return String(this.value == null ? '' : this.value)
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
      },
      isSelected (optionValue) {
        if (this.multiSelect) return this.selectedKeys().includes(String(optionValue))
        return Number(this.value) === Number(optionValue)
      },
      onSelect (key) {
        if (!this.multiSelect) {
          // 原單選：以該 key 取代（行為與改動前逐字相同）
          this.$emit('change', key)
          return
        }
        // 多選：toggle 該 key，回傳逗號多值字串（空選集 → 空字串）
        const keys = this.selectedKeys()
        const k = String(key)
        const idx = keys.indexOf(k)
        if (idx >= 0) keys.splice(idx, 1)
        else keys.push(k)
        this.$emit('change', keys.join(','))
      },
      checkExceptionWord (value) {
        if(this.category.toLowerCase() === 'ulcer stage' && value === 'scar'){
          return this.$t('finding_words.ulcer_scar')
        }
        return this.transI18n(value)
      }
    },
    computed: {
      modifyOptions () {
        return Object.entries(this.options).map(([key, value]) => {
          return {
            key,
            value,
            caption: this.prefixObj[value] || ''
          }
        })
      }
    }
	}
</script>

<style lang="scss">
  @import '@/styles/components/laidOutSelectInput.scss';
</style>